export const SET_ARIA_HIDDEN_MAIN_CONTENT = 'SET_ARIA_HIDDEN_MAIN_CONTENT';
export const MODAL_SET = 'MODAL_SET';
export const MODAL_CLEAR = 'MODAL_CLEAR';
export const SCREEN_RESIZED = 'SCREEN_RESIZED';
